<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_notice_info.path')" :paths="paths"></g-page-title>
    </template>
    <g-contents>

      <div class="-container-resizing">
        <div class="-p-5">
          <section class="-wrapper-column -wrapper-tile">
            <div class="-header">
              <p class="-h2">{{ $t('pages_notice_list.page_title') }}</p>
              <div>
                <g-button id="notice-info-edit-button" variant="secondary" size="small" @click="onClickNoticeEdit"
                          v-if="userInfo.auth === AUTH_GROUP.BespinAdmin">
                  <g-icon name="edit"></g-icon>
                  <span>{{ $t('pages_notice_info.edit') }}</span>
                </g-button>
                  <g-button id="notice-info-delete-button" variant="secondary" size="small" @click="onClickNoticeDelete" v-if="userInfo.auth === AUTH_GROUP.BespinAdmin">
                  <g-icon name="edit"></g-icon>
                  <span>{{ $t('pages_notice_info.delete') }}</span>
                </g-button>
              </div>
            </div>

            <div class="-width-100 -tile-container nowrap- white-space-normal">
              <section class="-wrapper-tile">
                <div class="-div-table -pb-0">
                  <div class="-row">
                    <div class="-row-header" style="width: 14.7%;">
                      <h5 class="-font-size-12">{{ $t('pages_notice_info.title') }}</h5>
                    </div>
                    <div class="-row-contents" style="word-break: break-all">
                      <p class="-wrapper-v-center">
                        <span id="notice-info-title" class="-font-size-14 -mr-1">{{ notice.title }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div class="-width-100 -tile-container -wrapper-half nowrap- white-space-normal">
              <section class="-wrapper-tile">
                <div class="-div-table -py-0">
                  <div class="-row">
                    <div class="-row-header">
                      <h5 id="notice-info-creatorId" class="-font-size-12">{{ $t('pages_notice_info.creatorId') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span class="-font-size-14 -mr-2" v-if="notice.creatorId">{{ notice.creatorId }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12">{{ $t('pages_product_ProductInfo.title.12') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <div class="-wrapper-v-center -button-ui" v-if="notice.fileId" id="notice-info-file-download"
                           @click="onClickDownload(notice.fileId)">
                        <g-icon :name="getFileIcon(notice.fileName)" size="large" class="nowrap- -mr-2"/>
                        <span class="-font-size-14 darkgray-1" id="notice-info-file-name">{{ notice.fileName }}</span>
                      </div>
                      <div class="-wrapper-v-center" v-else>
                        <span class="-paragraph -ml-1 -font-size-14">-</span>
                      </div>
                    </div>
                  </div>
                  <div class="-row" v-if="userInfo.auth === AUTH_GROUP.BespinAdmin">
                    <div class="-row-header">
                      <h5 class="-font-size-12">{{ $t('pages_notice_info.visible_status') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span id="notice-info-visible" class="-font-size-14 -mr-2">{{ !notice.visible ? this.$t('pages_notice.no_show') : this.$t('pages_notice.show') }} </span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section class="-wrapper-tile">
                <div class="-div-table -py-0">
                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12">{{ $t('pages_notice_list.hit') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span id="notice-info-hit" class="-font-size-14 -mr-2">{{ notice.hit }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12">{{ $t('pages_notice_info.created') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span id="notice-info-created" class="-font-size-14 -mr-2" v-if="notice.created">{{ notice.created }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div class="-width-100 -tile-container nowrap- white-space-normal">
              <section class="-wrapper-tile">
                <div class="-div-table -pt-0">
                  <div class="-row">
                    <div class="-row-header" style="width: 14.7%;">
                      <h5 class="-font-size-12">{{ $t('pages_notice_info.content') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center">
                        <span id="notice-info-content" class="-font-size-14 -mr-2" v-if="notice.content"
                              v-html="notice.content.split('\n').join('<br />')"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </section>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import FileService from '@/services/FileServices'
import FileDownloader from '@/library/FileDownloader'
import {AUTH_GROUP} from "@/constants/constants";
import ConfirmPopup from "@/pages/components/ConfirmPopup";

export default {
  name: 'notice-info',
  componentName: 'NoticeInfo',
  data() {
    return {
      paths: [{
        path: '/notice/list',
        name: this.$t('pages_notice.path')
      }, {
        name: this.$t('pages_notice_info.path')
      }],
      AUTH_GROUP: AUTH_GROUP
    }
  },
  computed: {
    ...mapGetters('notice', ['notice']),
    ...mapGetters('user', ['userInfo']),
  },
  methods: {
    ...mapActions('notice', ['getNotice', 'updateVisible', 'setSelectNotice', 'deleteNotice']),
    onClickDownload(fileId) {
      FileDownloader.fileDownload(fileId)
    },
    onClickNoticeEdit() {
      this.setSelectNotice(this.notice)
      this.$router.push(`/notice/edit?id=${this.notice.id}`)
    },
    onClickNoticeDelete(){

      this.$popupManager.open(ConfirmPopup, {
        text: this.$t('pages_notice_info.delete_text'),
        onConfirm: () => {
          this.deleteNotice(this.notice.id)
          this.$showToast(this.$t('pages_notice_delete.title_text'))
          this.$router.push('/notice/list')
        }
      })

    },
    onClickNoticeVisible() {
      let message = this.$t('pages_notice_info.visible_false_text')
      if(!this.notice.visible) {
        message = this.$t('pages_notice_info.visible_true_text')
      }

      this.$popupManager.open(ConfirmPopup, {
        text: message,
        onConfirm: () => {
          this.updateVisible(this.notice.id)
          this.$router.push(`/notice/list`)
        }
      })

    },
    getFileIcon(fileName) {
      return FileDownloader.getFileIcon(fileName)
    }
  },
  beforeMount() {
    const id = this.$route.query.id
    this.getNotice(id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/notice/NoticeInfo.vue